import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
export default new Vuex.Store({
    state: {
        // 框架配置
        main: {
            baseUrl: process.env.BASE_URL,
        },
        // 基础配置
        basic: {
            token: '',
            version: '',
            userInfo: {},
        },
        // 权限信息
        materialPermission: {}
    },
    mutations: {
        RESET_GLOBAL_STATE (state, payload) {
            state[payload.key] = { ...state[payload.key], ...payload.value };
        },
        SET_BASIC_STATE (state, payload) {
            state.basic[payload.key] = payload.value;
        },
    },
    getters: {
        userInfo (state) {
            return state.basic.userInfo;
        },
        materialPermission (state) {
            return state.materialPermission;
        }
    },
    actions: {},
    modules: {},
});
